export interface HKDistrict {
  code: string;
  name_zh_hk: string;
  name_zh_cn: string;
  name_en: string;
}

export interface HKRegion {
  code: string;
  name_zh_hk: string;
  name_zh_cn: string;
  name_en: string;
  districts: HKDistrict[];
}

const HK_REGIONS_AND_DISTRICTS_RAW: HKRegion[] = [
  {
    code: 'hk-island',
    name_zh_hk: '香港島',
    name_zh_cn: '香港岛',
    name_en: 'Hong Kong Island',
    districts: [
      { code: 'aberdeen', name_zh_hk: '香港仔', name_zh_cn: '香港仔', name_en: 'Aberdeen' },
      { code: 'admiralty', name_zh_hk: '金鐘', name_zh_cn: '金钟', name_en: 'Admiralty' },
      { code: 'ap-lei-chau', name_zh_hk: '鴨脷洲', name_zh_cn: '鸭脷洲', name_en: 'Ap Lei Chau' },
      { code: 'causeway-bay', name_zh_hk: '銅鑼灣', name_zh_cn: '铜锣湾', name_en: 'Causeway Bay' },
      { code: 'central', name_zh_hk: '中環', name_zh_cn: '中环', name_en: 'Central' },
      { code: 'chai-wan', name_zh_hk: '柴灣', name_zh_cn: '柴湾', name_en: 'Chai Wan' },
      { code: 'chung-hom-kok', name_zh_hk: '舂坎角', name_zh_cn: '舂坎角', name_en: 'Chung Hom Kok' },
      { code: 'deep-water-bay', name_zh_hk: '深水灣', name_zh_cn: '深水湾', name_en: 'Deep Water Bay' },
      { code: 'happy-valley', name_zh_hk: '跑馬地', name_zh_cn: '跑马地', name_en: 'Happy Valley' },
      { code: 'kennedy-town', name_zh_hk: '堅尼地城', name_zh_cn: '坚尼地城', name_en: 'Kennedy Town' },
      { code: 'mid-levels', name_zh_hk: '半山區', name_zh_cn: '半山区', name_en: 'Mid-levels' },
      { code: 'north-point', name_zh_hk: '北角', name_zh_cn: '北角', name_en: 'North Point' },
      { code: 'pok-fu-lam', name_zh_hk: '薄扶林', name_zh_cn: '薄扶林', name_en: 'Pok Fu Lam' },
      { code: 'quarry-bay', name_zh_hk: '鰂魚涌', name_zh_cn: '鲗鱼涌', name_en: 'Quarry Bay' },
      { code: 'repulse-bay', name_zh_hk: '淺水灣', name_zh_cn: '浅水湾', name_en: 'Repulse Bay' },
      { code: 'sai-wan-ho', name_zh_hk: '西灣河', name_zh_cn: '西湾河', name_en: 'Sai Wan Ho' },
      { code: 'sai-ying-pun', name_zh_hk: '西營盤', name_zh_cn: '西营盘', name_en: 'Sai Ying Pun' },
      { code: 'shau-kei-wan', name_zh_hk: '筲箕灣', name_zh_cn: '筲箕湾', name_en: 'Shau Kei Wan' },
      { code: 'shek-o', name_zh_hk: '石澳', name_zh_cn: '石澳', name_en: 'Shek O' },
      { code: 'shek-tong-tsui', name_zh_hk: '石塘咀', name_zh_cn: '石塘咀', name_en: 'Shek Tong Tsui' },
      { code: 'sheung-wan', name_zh_hk: '上環', name_zh_cn: '上环', name_en: 'Sheung Wan' },
      { code: 'stanley', name_zh_hk: '赤柱', name_zh_cn: '赤柱', name_en: 'Stanley' },
      { code: 'tai-hang', name_zh_hk: '大坑', name_zh_cn: '大坑', name_en: 'Tai Hang' },
      { code: 'tai-tam', name_zh_hk: '大潭', name_zh_cn: '大潭', name_en: 'Tai Tam' },
      { code: 'the-peak', name_zh_hk: '山頂', name_zh_cn: '山顶', name_en: 'The Peak' },
      { code: 'wan-chai', name_zh_hk: '灣仔', name_zh_cn: '湾仔', name_en: 'Wan Chai' },
      { code: 'wong-chuk-hang', name_zh_hk: '黃竹坑', name_zh_cn: '黄竹坑', name_en: 'Wong Chuk Hang' },
      { code: 'eastern', name_zh_hk: '東區', name_zh_cn: '东区', name_en: 'Eastern' },
      { code: 'central-western', name_zh_hk: '中西區', name_zh_cn: '中西区', name_en: 'Central Western' }
    ]
  },
  {
    code: 'kowloon',
    name_zh_hk: '九龍',
    name_zh_cn: '九龙',
    name_en: 'Kowloon',
    districts: [
      { code: 'cha-kwo-ling', name_zh_hk: '茶果嶺', name_zh_cn: '茶果岭', name_en: 'Cha Kwo Ling' },
      { code: 'cheung-sha-wan', name_zh_hk: '長沙灣', name_zh_cn: '长沙湾', name_en: 'Cheung Sha Wan' },
      { code: 'diamond-hill', name_zh_hk: '鑽石山', name_zh_cn: '钻石山', name_en: 'Diamond Hill' },
      { code: 'ho-man-tin', name_zh_hk: '何文田', name_zh_cn: '何文田', name_en: 'Ho Man Tin' },
      { code: 'hung-hom', name_zh_hk: '紅磡', name_zh_cn: '红磡', name_en: 'Hung Hom' },
      { code: 'kowloon-bay', name_zh_hk: '九龍灣', name_zh_cn: '九龙湾', name_en: 'Kowloon Bay' },
      { code: 'kowloon-city', name_zh_hk: '九龍城', name_zh_cn: '九龙城', name_en: 'Kowloon City' },
      { code: 'kowloon-tong', name_zh_hk: '九龍塘', name_zh_cn: '九龙塘', name_en: 'Kowloon Tong' },
      { code: 'kwun-tong', name_zh_hk: '觀塘', name_zh_cn: '观塘', name_en: 'Kwun Tong' },
      { code: 'lai-chi-kok', name_zh_hk: '荔枝角', name_zh_cn: '荔枝角', name_en: 'Lai Chi Kok' },
      { code: 'lam-tin', name_zh_hk: '藍田', name_zh_cn: '蓝田', name_en: 'Lam Tin' },
      { code: 'lok-fu', name_zh_hk: '樂富', name_zh_cn: '乐富', name_en: 'Lok Fu' },
      { code: 'mong-kok', name_zh_hk: '旺角', name_zh_cn: '旺角', name_en: 'Mong Kok' },
      { code: 'ngau-chi-wan', name_zh_hk: '牛池灣', name_zh_cn: '牛池湾', name_en: 'Ngau Chi Wan' },
      { code: 'ngau-tau-kok', name_zh_hk: '牛頭角', name_zh_cn: '牛头角', name_en: 'Ngau Tau Kok' },
      { code: 'san-po-kong', name_zh_hk: '新蒲崗', name_zh_cn: '新蒲岗', name_en: 'San Po Kong' },
      { code: 'sau-mau-ping', name_zh_hk: '秀茂坪', name_zh_cn: '秀茂坪', name_en: 'Sau Mau Ping' },
      { code: 'sham-shui-po', name_zh_hk: '深水埗', name_zh_cn: '深水埗', name_en: 'Sham Shui Po' },
      { code: 'shek-kip-mei', name_zh_hk: '石硤尾', name_zh_cn: '石硖尾', name_en: 'Shek Kip Mei' },
      { code: 'tai-kok-tsui', name_zh_hk: '大角咀', name_zh_cn: '大角咀', name_en: 'Tai Kok Tsui' },
      { code: 'to-kwa-wan', name_zh_hk: '土瓜灣', name_zh_cn: '土瓜湾', name_en: 'To Kwa Wan' },
      { code: 'tsim-sha-tsui', name_zh_hk: '尖沙咀', name_zh_cn: '尖沙咀', name_en: 'Tsim Sha Tsui' },
      { code: 'tsz-wan-shan', name_zh_hk: '慈雲山', name_zh_cn: '慈云山', name_en: 'Tsz Wan Shan' },
      { code: 'wang-tau-hom', name_zh_hk: '橫頭磡', name_zh_cn: '横头磡', name_en: 'Wang Tau Hom' },
      { code: 'wong-tai-sin', name_zh_hk: '黃大仙', name_zh_cn: '黄大仙', name_en: 'Wong Tai Sin' },
      { code: 'yau-ma-tei', name_zh_hk: '油麻地', name_zh_cn: '油麻地', name_en: 'Yau Ma Tei' },
      { code: 'yau-tong', name_zh_hk: '油塘', name_zh_cn: '油塘', name_en: 'Yau Tong' },
      { code: 'yau-yat-chuen', name_zh_hk: '又一村', name_zh_cn: '又一村', name_en: 'Yau Yat Chuen' }
    ]
  },
  {
    code: 'new-territories',
    name_zh_hk: '新界',
    name_zh_cn: '新界',
    name_en: 'New Territories',
    districts: [
      { code: 'yuen-long', name_zh_hk: '元朗', name_zh_cn: '元朗', name_en: 'Yuen Long' },
      { code: 'tuen-mun', name_zh_hk: '屯門', name_zh_cn: '屯门', name_en: 'Tuen Mun' },
      { code: 'tsuen-wan', name_zh_hk: '荃灣', name_zh_cn: '荃湾', name_en: 'Tsuen Wan' },
      { code: 'ting-kau', name_zh_hk: '汀九', name_zh_cn: '汀九', name_en: 'Ting Kau' },
      { code: 'tin-shui-wai', name_zh_hk: '天水圍', name_zh_cn: '天水围', name_en: 'Tin Shui Wai' },
      { code: 'tai-po-lam-tsuen', name_zh_hk: '大埔林村', name_zh_cn: '大埔林村', name_en: 'Tai Po - Lam Tsuen' },
      { code: 'tai-po-ting-kok', name_zh_hk: '大埔汀角', name_zh_cn: '大埔汀角', name_en: 'Tai Po - Ting Kok' },
      { code: 'tai-po-kau', name_zh_hk: '大埔滘', name_zh_cn: '大埔滘', name_en: 'Tai Po Kau' },
      { code: 'tai-po', name_zh_hk: '大埔', name_zh_cn: '大埔', name_en: 'Tai Po' },
      { code: 'tai-lam', name_zh_hk: '大欖', name_zh_cn: '大榄', name_en: 'Tai Lam' },
      { code: 'ta-ku-ling', name_zh_hk: '打鼓嶺', name_zh_cn: '打鼓岭', name_en: 'Ta Ku Ling' },
      { code: 'so-kwun-wat', name_zh_hk: '掃管笏', name_zh_cn: '扫管笏', name_en: 'So Kwun Wat' },
      { code: 'sheung-shui', name_zh_hk: '上水', name_zh_cn: '上水', name_en: 'Sheung Shui' },
      { code: 'shek-kwu-chau', name_zh_hk: '石鼓洲', name_zh_cn: '石鼓洲', name_en: 'Shek Kwu Chau' },
      { code: 'sham-tseng', name_zh_hk: '深井', name_zh_cn: '深井', name_en: 'Sham Tseng' },
      { code: 'sha-tin-tai-wai', name_zh_hk: '沙田大圍', name_zh_cn: '沙田大围', name_en: 'Sha Tin - Tai Wai' },
      { code: 'sha-tin-siu-lek-yuen', name_zh_hk: '沙田小瀝源', name_zh_cn: '沙田小沥源', name_en: 'Sha Tin - Siu Lek Yuen' },
      { code: 'sha-tin-fo-tan', name_zh_hk: '沙田火炭', name_zh_cn: '沙田火炭', name_en: 'Sha Tin - Fo Tan' },
      { code: 'sha-tin', name_zh_hk: '沙田', name_zh_cn: '沙田', name_en: 'Sha Tin' },
      { code: 'sha-tau-kok', name_zh_hk: '沙頭角', name_zh_cn: '沙头角', name_en: 'Sha Tau Kok' },
      { code: 'tseung-kwan-o', name_zh_hk: '將軍澳', name_zh_cn: '将军澳', name_en: 'Tseung Kwan O' },
      { code: 'sai-kung', name_zh_hk: '西貢', name_zh_cn: '西贡', name_en: 'Sai Kung' },
      { code: 'ping-che', name_zh_hk: '坪輋', name_zh_cn: '坪輋', name_en: 'Ping Che' },
      { code: 'peng-chau', name_zh_hk: '坪洲', name_zh_cn: '坪洲', name_en: 'Peng Chau' },
      { code: 'north', name_zh_hk: '北區', name_zh_cn: '北区', name_en: 'North' },
      { code: 'ma-wan', name_zh_hk: '馬灣', name_zh_cn: '马湾', name_en: 'Ma Wan' },
      { code: 'ma-on-shan', name_zh_hk: '馬鞍山', name_zh_cn: '马鞍山', name_en: 'Ma On Shan' },
      { code: 'lau-fau-shan', name_zh_hk: '流浮山', name_zh_cn: '流浮山', name_en: 'Lau Fau Shan' },
      { code: 'lantau-island-tung-chung', name_zh_hk: '大嶼山東涌', name_zh_cn: '大屿山东涌', name_en: 'Lantau Island - Tung Chung' },
      { code: 'lantau-island-tong-fuk', name_zh_hk: '大嶼山塘福', name_zh_cn: '大屿山塘福', name_en: 'Lantau Island - Tong Fuk' },
      { code: 'lantau-island-tai-o', name_zh_hk: '大嶼山大澳', name_zh_cn: '大屿山大澳', name_en: 'Lantau Island - Tai O' },
      { code: 'lantau-island-shek-pik', name_zh_hk: '大嶼山石壁', name_zh_cn: '大屿山石壁', name_en: 'Lantau Island - Shek Pik' },
      { code: 'lantau-island-ngong-ping', name_zh_hk: '大嶼山昂坪', name_zh_cn: '大屿山昂坪', name_en: 'Lantau Island - Ngong Ping' },
      { code: 'lantau-island-mui-wo', name_zh_hk: '大嶼山梅窩', name_zh_cn: '大屿山梅窝', name_en: 'Lantau Island - Mui Wo' },
      { code: 'lantau-island-discovery-bay', name_zh_hk: '大嶼山愉景灣', name_zh_cn: '大屿山愉景湾', name_en: 'Lantau Island - Discovery Bay' },
      { code: 'lantau-island-chi-ma-wan', name_zh_hk: '大嶼山芝麻灣', name_zh_cn: '大屿山芝麻湾', name_en: 'Lantau Island - Chi Ma Wan' },
      { code: 'lantau-island-cheung-sha', name_zh_hk: '大嶼山長沙', name_zh_cn: '大屿山长沙', name_en: 'Lantau Island - Cheung Sha' },
      { code: 'lantau-island-chek-lap-kok', name_zh_hk: '大嶼山赤鱲角', name_zh_cn: '大屿山赤鱲角', name_en: 'Lantau Island - Chek Lap Kok' },
      { code: 'lantau-island', name_zh_hk: '大嶼山', name_zh_cn: '大屿山', name_en: 'Lantau Island' },
      { code: 'lamma-island', name_zh_hk: '南丫島', name_zh_cn: '南丫岛', name_en: 'Lamma Island' },
      { code: 'kwu-tung', name_zh_hk: '古洞', name_zh_cn: '古洞', name_en: 'Kwu Tung' },
      { code: 'kwai-tsing', name_zh_hk: '葵青區', name_zh_cn: '葵青区', name_en: 'Kwai Tsing' },
      { code: 'kwai-chung', name_zh_hk: '葵涌', name_zh_cn: '葵涌', name_en: 'Kwai Chung' },
      { code: 'hung-shui-kiu', name_zh_hk: '洪水橋', name_zh_cn: '洪水桥', name_en: 'Hung Shui Kiu' },
      { code: 'islands', name_zh_hk: '離島區', name_zh_cn: '离岛区', name_en: 'Islands' },
      { code: 'hei-ling-chau', name_zh_hk: '喜靈洲', name_zh_cn: '喜灵洲', name_en: 'Hei Ling Chau' },
      { code: 'grass-island', name_zh_hk: '塔門', name_zh_cn: '塔门', name_en: 'Grass Island' },
      { code: 'fanling-kwan-tei', name_zh_hk: '粉嶺軍地', name_zh_cn: '粉岭军地', name_en: 'Fanling - Kwan Tei' },
      { code: 'fanling', name_zh_hk: '粉嶺', name_zh_cn: '粉岭', name_en: 'Fanling' },
      { code: 'crooked-island', name_zh_hk: '吉澳', name_zh_cn: '吉澳', name_en: 'Crooked Island' },
      { code: 'clear-water-bay', name_zh_hk: '清水灣', name_zh_cn: '清水湾', name_en: 'Clear Water Bay' },
      { code: 'cheung-chau', name_zh_hk: '長洲', name_zh_cn: '长洲', name_en: 'Cheung Chau' }
    ]
  },
]; 

export const HK_REGIONS_AND_DISTRICTS: HKRegion[] = HK_REGIONS_AND_DISTRICTS_RAW;
